import React, { useState } from 'react';
import { 
  Form, 
  Input, 
  Button, 
  Card, 
  Typography, 
  message, 
  Spin,
  Row,
  Col
} from 'antd';
import { LockOutlined } from '@ant-design/icons';
import axios from 'axios';
import { getUserData } from '../../../hooks/Auth';

const { Title } = Typography;
const API_BASE_URL = "https://techcrew.pk/ulc/";

const ChangePassword = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const user = getUserData();
  const userId = user?.user?.id;

  const onFinish = async (values) => {
    if (values.newPassword !== values.confirmPassword) {
      message.error('New password and confirm password do not match!');
      return;
    }
    const data ={
      user_id: userId,
        currentPassword: values.currentPassword, // Add current password
        newPassword: values.newPassword
    }
    console.log("data",data);
  
    try {
      setLoading(true);
      const response = await axios.post(`${API_BASE_URL}ChangePassword.php`, {
        user_id: userId,
        currentPassword: values.currentPassword, // Add current password
        newPassword: values.newPassword
      }, {
        headers: {
          'Content-Type': 'application/json' // Explicitly set content type
        }
      });
  
      if (response.data.status.code === 200) {
        message.success(response.data.status.message);
        form.resetFields();
      } else {
        throw new Error(response.data.status.message || "Password change failed");
      }
    } catch (error) {
      console.error("Password change error:", error);
      const errorMessage = error.response?.data?.status?.message || 
                         error.message || 
                         "Password change failed. Please try again.";
      message.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const passwordRules = [
    { required: true, message: 'Please input your password!' },
    { min: 8, message: 'Password must be at least 8 characters long!' },
    {
      pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/,
      message: 'Password must contain at least one uppercase letter, one lowercase letter, and one number!'
    }
  ];

  return (
    <div style={{ paddingLeft: "250px", paddingTop: "60px" }}>
      <Row justify="center">
        <Col xs={24} sm={20} md={16} lg={12}>
          <Card
            title={
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <LockOutlined style={{ fontSize: '24px', color: '#1890ff', marginRight: '16px' }} />
                <Title level={4} style={{ margin: 0 }}>Change Password</Title>
              </div>
            }
            bordered={false}
          >
            <Form
              form={form}
              name="change_password"
              onFinish={onFinish}
              layout="vertical"
              autoComplete="off"
            >
              <Form.Item
                label="Current Password"
                name="currentPassword"
                rules={[{ required: true, message: 'Please input your current password!' }]}
              >
                <Input.Password 
                  placeholder="Enter current password" 
                  prefix={<LockOutlined />} 
                />
              </Form.Item>

              <Form.Item
                label="New Password"
                name="newPassword"
                rules={passwordRules}
                hasFeedback
              >
                <Input.Password 
                  placeholder="Enter new password" 
                  prefix={<LockOutlined />} 
                />
              </Form.Item>

              <Form.Item
                label="Confirm New Password"
                name="confirmPassword"
                dependencies={['newPassword']}
                hasFeedback
                rules={[
                  { required: true, message: 'Please confirm your new password!' },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue('newPassword') === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error('The two passwords do not match!'));
                    },
                  }),
                ]}
              >
                <Input.Password 
                  placeholder="Confirm new password" 
                  prefix={<LockOutlined />} 
                />
              </Form.Item>

              <Form.Item>
                <Button 
                  type="primary" 
                  htmlType="submit" 
                  block
                  loading={loading}
                  icon={<LockOutlined />}
                >
                  Change Password
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default ChangePassword;